import { render, staticRenderFns } from "./VoteUserTemplate.vue?vue&type=template&id=77b49543&scoped=true&"
import script from "./VoteUserTemplate.vue?vue&type=script&lang=js&"
export * from "./VoteUserTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VoteUserTemplate.vue?vue&type=style&index=0&id=77b49543&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b49543",
  null
  
)

export default component.exports